import React from 'react';

const ProgressBar = ({ progress, showDetails = true, className = '' }) => {
  const { percentDone, actual, defect, remaining, totalDefect, finalOutput } = progress;

  return (
    <div className={`space-y-2 ${className}`}>
      <div className="flex items-center gap-2">
        <div className="w-full bg-gray-700 rounded-full h-2.5">
          <div 
            className="bg-blue-600 h-2.5 rounded-full transition-all duration-300" 
            style={{ width: `${percentDone}%` }}
          />
        </div>
        <span className="text-sm text-gray-400">{percentDone}%</span>
      </div>
      {showDetails && (
        <div className="grid grid-cols-3 gap-2 text-sm text-gray-400">
          <div>
            <p>Факт: {actual || finalOutput?.actual || 0}</p>
          </div>
          <div>
            <p>Брак: {defect || totalDefect || 0}</p>
          </div>
          <div>
            <p>Осталось: {remaining || 0}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProgressBar; 